import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { DtAddressService } from '../../../service/dt-address/dt-address.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9140.component.html',
  styleUrls: ['wa9140.component.scss']
})
export class Wa9140Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9140:届先マスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  private isEnableClearFilter = false;

  private isShowWa9142 = false;
  private isShowWa9143 = false;
  private isShowWa9183 = false;
  private isShowSendLoading = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isShowDeleteModal = false;

  constructor(private router: Router, private dtAddressService: DtAddressService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      suppressRowClickSelection: false,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9140_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
        this.gridHelper.renderGridCheckboxImage();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus']
      },
      {
        field: 'updcounterNr',
        hide: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先コード',
        field: 'dtaddressCd',
        sort: 'asc',
        width: this.getColumnWidth('dtaddressCd', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        width: this.getColumnWidth('dtnameTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先郵便番号',
        field: 'dtpostalCd',
        width: this.getColumnWidth('dtpostalCd', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '届先住所1',
        field: 'dtaddress1Tx',
        width: this.getColumnWidth('dtaddress1Tx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所2',
        field: 'dtaddress2Tx',
        width: this.getColumnWidth('dtaddress2Tx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先住所3',
        field: 'dtaddress3Tx',
        width: this.getColumnWidth('dtaddress3Tx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先電話番号',
        field: 'dttelTx',
        width: this.getColumnWidth('dttelTx', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '配送方法',
        field: 'carrierTx',
        width: this.getColumnWidth('carrierTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送エリアコード',
        field: 'deliareaCd',
        width: this.getColumnWidth('deliareaCd', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送エリア名',
        field: 'deliareaTx',
        width: this.getColumnWidth('deliareaTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送ルートコード',
        field: 'delirouteCd',
        width: this.getColumnWidth('delirouteCd', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '配送ルート名',
        field: 'delirouteTx',
        width: this.getColumnWidth('delirouteTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '納品書区分名',
        field: 'typeshipinvoiceTx',
        width: this.getColumnWidth('typeshipinvoiceTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フリー項目1',
        field: 'freeItem1Tx',
        width: this.getColumnWidth('freeItem1Tx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フリー項目2',
        field: 'freeItem2Tx',
        width: this.getColumnWidth('freeItem2Tx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9140_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9140_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa9140_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    sessionStorage.removeItem('isShowOwnerSelect');
    setTimeout(() => {
      this.onSubmit();
    }, 1000);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.dtAddressService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.rowData = outputJson.dtaddresses;

        setTimeout(() => {
          this.gridHelper.selectedAnimate();
          this.gridOptions.api.hideOverlay();
          this.working = false;
        }, 100);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  reg() {
    this.router.navigate(['wa9142']);
  }

  upd() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('dtaddressOneSelect', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa9143']);
  }

  del() {
    this.isShowSendLoading = true;
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.isShowSendLoading = false;
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedId = this.rowData[selectedIndex]['dtaddressId'];
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.dtAddressService
      .delete(selectedId)
      .then(outputJson => {
        this.working = false;
        this.isShowDeleteModal = false;
        this.onSubmit();
        sessionStorage.setItem('SuccessInfoMessage', '削除が完了しました。');
        this.isShowSendLoading = false;
      })
      .catch(error => {
        this.working = false;
        this.isShowDeleteModal = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
      });

  }

  showWa9142() {
    this.errorInfo = '';
    this.isShowWa9142 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9142(isRefreshGrid: boolean) {
    this.isShowWa9142 = false;
    if (isRefreshGrid) this.onSubmit();
    //sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showWa9143() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    sessionStorage.setItem('rowItem', JSON.stringify(this.gridOptions.api.getSelectedNodes()[0]['data']));
    this.isShowWa9143 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9143(isRefreshGrid: boolean) {
    this.isShowWa9143 = false;
    if (isRefreshGrid) {
      this.gridHelper.prepareSelectedAnimate();
      this.onSubmit();
    }
    //sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  showWa9183() {
    this.isShowWa9183 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onClose9183(isRefreshGrid: boolean) {
    this.isShowWa9183 = false;
    if (isRefreshGrid) this.onSubmit();
    //sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      this.onSubmit();
    } else {
      delete this.rowData;
    }
  }

  onShowDeleteModal() {
    this.errorInfo = '';
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    this.isShowDeleteModal = true;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9140/wa9140.component.ts